<template>
    <li class="meal--ingredient" @click="getIngredient(id)">
        <svg class="icon icon-chart">
            <use xlink:href="#icon-chart"></use>
        </svg>
        <span>{{ quantity }}</span>
        <span>{{ unit }}</span>
        <span>{{ name }}</span>
    </li>
</template>

<script>
import axios from 'axios';
import state from './../state.js';

export default {
    props: ['quantity', 'unit', 'name', 'id'],

    data() {
        return {
            state
        };
    },

    methods: {
        getIngredient(id) {
            axios
                .get('/recept/api/menu/meal/ingredient/' + id)
                .then((response) => {
                    this.state.charts = response.data;
                    this.state.chartHeader.title = this.name;
                    this.state.chartHeader.subtitle = 'Näringsvärde per 100 gram';
                })
                .catch((error) => {});
        }
    }
};
</script>
